module.exports = __webpack_public_path__ + "img/products_big_can_sugar_ru.eaa3e430.png";